/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesAliases {
  BREADCRUMB_0 = 'breadcrumb-0',
  CALL_CATEGORY_FRAGMENT = 'call-category-fragment',
  CALL_CATEGORY_ROUTE = 'call-category-route',
  FRAGMENT_CALLS = 'fragment-calls',
  FRAGMENT_CHANGE_PW = 'fragment-change-pw',
  FRAGMENT_DETAILS_CALLED = 'fragment-details-called',
  FRAGMENT_FORM_PROVIDER_ACCREDITATION_NEW = 'fragment-form-provider-accreditation-new',
  FRAGMENT_FORM_TECHNICAL_VISIT = 'fragment-form-technical-visit',
  FRAGMENT_MY_DATA = 'fragment-my-data',
  FRAGMENT_NEGOTIATION = 'fragment-negotiation',
  FRAGMENT_NEGOTIATION_TABCONTROL = 'fragment-negotiation-tabcontrol',
  FRAGMENT_NEW_CALL = 'fragment-new-call',
  FRAGMENT_PRIVACY = 'fragment-privacy',
  FRAGMENT_PRIVACY_WARNING = 'fragment-privacy-warning',
  FRAGMENT_PROVIDER_ACCREDITATION = 'fragment-provider-accreditation',
  FRAGMENT_TECHNICAL_VISIT = 'fragment-technical-visit',
  FRAGMENT_TERM_PROVIDER_ACCREDITATION = 'fragment-term-provider-accreditation',
  FRAGMENT_TERM_USE = 'fragment-term-use',
  FRAGMENT_VISIT_DETAILS = 'fragment-visit-details',
  LAYOUT_ROUTES = 'layout-routes',
  PANEL_ROUTES = 'panel-routes',
  ROUTE_CALLS = 'route-calls',
  ROUTE_CHANGE_PW = 'route-change-pw',
  ROUTE_DETAILS_CALLED = 'route-details-called',
  ROUTE_FORM_PROVIDER_ACCREDITATION_NEW = 'route-form-provider-accreditation-new',
  ROUTE_FORM_TECHNICAL_VISIT = 'route-form-technical-visit',
  ROUTE_MY_DATA = 'route-my-data',
  ROUTE_NEGOTIATION = 'route-negotiation',
  ROUTE_NEGOTIATION_TABCONTROL = 'route-negotiation-tabcontrol',
  ROUTE_NEW_CALL = 'route-new-call',
  ROUTE_PRIVACY = 'route-privacy',
  ROUTE_PRIVACY_WARNING = 'route-privacy-warning',
  ROUTE_PROVIDER_ACCREDITATION = 'route-provider-accreditation',
  ROUTE_TECHNICAL_VISIT = 'route-technical-visit',
  ROUTE_TERM_PROVIDER_ACCREDITATION = 'route-term-provider-accreditation',
  ROUTE_TERM_USE = 'route-term-use',
  ROUTE_VISIT_DETAILS = 'route-visit-details',
}
export { RoutesAliases };
